

import Config from "../Config";

import { useState, useEffect} from "react";

import input_check from "../input_check.png";
import input_error from "../input_error.png";


function InputSearchKid(props)
{

    var cData = null;

    cData = Config.getFromBuffer(Config.cache_kids_search,3600, props.userData);
     
    
    //const [val, setVal] = useState(props.value);
    const [val, setVal] = useState(props.val);
    const [req, setRequired] = useState(props.req);
    const [firstUp, setFirstUp] = useState(props.firstUp);
    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);

    const [showSelect, setShowSelect] = useState(false);

    const [tab, setTab] = useState(cData); 
  

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
   

    const checkAndChange = (e) =>
    {

 

        var v = e.target.value;

        setShowSelect(true);

        console.log(v);

        if(firstUp != undefined && firstUp == '1')
        {
            v =  v.charAt(0).toUpperCase() + v.slice(1);
        }


        setVal(v);

       

        var correct = true;

        if(req == '1' && v.length < 1) correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'');
            props.valChange('p_dziecko_id', '0', correct,'');

        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }



    const getKids = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_employessModule,kids_for_search', {
            method: 'POST', 
            body: JSON.stringify([]), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);       
                        Config.setToBuffer(Config.cache_kids_search, res.result, props.userData); 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const selectAndClose = (e) => {

        var id = e.target.getAttribute('id');
        var valx = e.target.getAttribute('val');
          
        console.log(id+' '+valx);

        setShowSelect(false);


        for(var k=0;k<tab.length; k++)
            {
                if(tab[k].id == id)
                    {
                        valx = tab[k].id + " | " + tab[k].grupa + " | " +  tab[k].imie+" " + tab[k].nazwisko;
                    }
            }

           
    


        if(props.kidSelected != null && props.kidSelected != undefined)
        {    
          
            props.kidSelected(id);
        }

       
        setVal(valx);
       
    }
    

    const closeDialog = () => {
        setShowSelect(false);
    }

    const showDialog = () => {
        setShowSelect(true);
    }


    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' && val != undefined && val.length < 1) correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }


    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }



    useEffect(() => {

        if(val != props.value && props.value != undefined) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);

     
             props.valChange(props.name, val, correct,'');
            
    
        }
    })


    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setTab([]);
    }



    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }



    if(tab == null)
    {
        setTab([]);
        getKids();    
    }


    var searchBox = null;
    var finded = new Array();


    if(val.length > 2 && tab != undefined )
    {
     
        finded = new Array();
        const valP = val.split(" ");

        for(var k=0;k<tab.length; k++)
        {                      
            if( valP[0].toLowerCase().length > 2 &&   (tab[k].nazwisko.toLowerCase().includes(valP[0].toLowerCase() ) || tab[k].imie.toLowerCase().includes(valP[0].toLowerCase() ))  )
            {               
                finded.push( tab[k] ); 
            } else
            if(  valP.length > 1 &&   valP[1].toLowerCase().length > 2 && (  tab[k].nazwisko.toLowerCase().includes(valP[1].toLowerCase() ) || tab[k].imie.toLowerCase().includes(valP[1].toLowerCase() ) )  )
            {               
                finded.push( tab[k] ); 
            } 
        }
    }

   

    if(finded.length > 0 && showSelect)
    {
     

            searchBox =   <div className="autocomplete shadowx">
                            <ul>
                                {
                                    finded.map( (item, ix) => {
                                        return <li key={"x"+ix}  id={item.id} val={item.nazwisko + " " + item.imie + ", " + item.grupa} onClick={selectAndClose}  >
                                                {item.nazwisko + " " + item.imie + ", " + item.grupa}
                                        </li>
                                    } )
                                }
                            </ul>
                        </div>  ;
    }



    return <fieldset>
           <input type="text"   onFocus={showDialog}   value={val} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={props.className + "   " + cn} />        
             {imgx}
             <br/>
             <span className="form_err">{err + " "} &nbsp; </span>    
             {searchBox}     
           </fieldset>
}


export default InputSearchKid;